import React from 'react';
import ViewEmployeeFunctional from './components/view-employee-functional';
import './view-employee.scss';

const ViewEmployee = () => {
	return <ViewEmployeeFunctional />;
};
export default ViewEmployee;
